import { DriverInvoiceResumeMonthOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchInvoiceResumeByMonth = (date: string) =>
  driverApi.get<void, DriverInvoiceResumeMonthOutput>(`/v1/invoice-resume/by-month/${date}`);

export const useFetchInvoiceResumeByMonth = (
  date: string,
  options: QueryOptions<typeof queryKeys.user.fetchInvoiceResumeByMonth, DriverInvoiceResumeMonthOutput> = {},
) =>
  useQuery(queryKeys.user.fetchInvoiceResumeByMonth(date), () => fetchInvoiceResumeByMonth(date), {
    staleTime: DEFAULT_CACHE_TIME,
    keepPreviousData: true,
    ...options,
  });

export const prefetchInvoiceResumeByMonth = (date: string) =>
  queryClient.prefetchQuery(queryKeys.user.fetchInvoiceResumeByMonth(date), () => fetchInvoiceResumeByMonth(date), {
    staleTime: DEFAULT_CACHE_TIME,
  });
